// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35we6","option":"styles_option__1oQiD","selected":"styles_selected__34-sJ"};